var map = {
	"./aia.svg": 2992,
	"./ant.svg": 2993,
	"./aus.svg": 2994,
	"./bah.svg": 2995,
	"./ban.svg": 2996,
	"./bar.svg": 2997,
	"./ber.svg": 2998,
	"./biz.svg": 2999,
	"./bot.svg": 3000,
	"./bru.svg": 3001,
	"./can.svg": 3002,
	"./cay.svg": 3003,
	"./cmr.svg": 3004,
	"./cok.svg": 3005,
	"./cyp.svg": 3006,
	"./dma.svg": 3007,
	"./eng.svg": 3008,
	"./fij.svg": 3009,
	"./flk.svg": 3010,
	"./gab.svg": 3011,
	"./gam.svg": 3012,
	"./ggy.svg": 3013,
	"./gha.svg": 3014,
	"./gib.svg": 3015,
	"./grn.svg": 3016,
	"./guy.svg": 3017,
	"./ind.svg": 3018,
	"./iom.svg": 3019,
	"./ivb.svg": 3020,
	"./jam.svg": 3021,
	"./jey.svg": 3022,
	"./ken.svg": 3023,
	"./kir.svg": 3024,
	"./lca.svg": 3025,
	"./les.svg": 3026,
	"./manifest.json": 863,
	"./mas.svg": 3027,
	"./maw.svg": 3028,
	"./mdv.svg": 3029,
	"./mlt.svg": 3030,
	"./moz.svg": 3031,
	"./mri.svg": 3032,
	"./msr.svg": 3033,
	"./nam.svg": 3034,
	"./nfk.svg": 3035,
	"./ngr.svg": 3036,
	"./nir.svg": 3037,
	"./niu.svg": 3038,
	"./nru.svg": 3039,
	"./nzl.svg": 3040,
	"./pak.svg": 3041,
	"./png.svg": 3042,
	"./rsa.svg": 3043,
	"./rwa.svg": 3044,
	"./sam.svg": 3045,
	"./sco.svg": 3046,
	"./sey.svg": 3047,
	"./sgp.svg": 3048,
	"./shn.svg": 3049,
	"./skn.svg": 3050,
	"./sle.svg": 3051,
	"./sol.svg": 3052,
	"./sri.svg": 3053,
	"./svg-country.svg": 3054,
	"./swz.svg": 3055,
	"./tan.svg": 3056,
	"./tca.svg": 3057,
	"./tga.svg": 3058,
	"./tog.svg": 3059,
	"./tto.svg": 3060,
	"./tuv.svg": 3061,
	"./uga.svg": 3062,
	"./van.svg": 3063,
	"./wal.svg": 3064,
	"./zam.svg": 3065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2991;